import { CustomHandle } from '~/utils/CustomHandle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Node de início
export const InicioNode = ({ data }) => (
    <div className={`node-inicio ${data.highlighted ? 'highlighted' : ''}`}>
        <FontAwesomeIcon icon="fa-solid fa-play" className="node-icon" />
        <span className="node-text">{data.label}</span>
        <CustomHandle type="source" position="bottom" connectionCount={1} />
    </div>
);
